import { type AutodetectPhone } from "./AutodetectPhone/data/interface";

export namespace Customers {
	export type CustomerAutodetectPhone = AutodetectPhone;

	// path inside redux
	export const ConstantCustomersSlice = {
		COUNTERPARTIES_ERRORS: "customers/counterparties/errors",
		COUNTERPARTIES_FILTERS: "customers/counterparties/filters",
		COUNTERPARTIES_DATA: "customers/counterparties/data",
		COUNTERPARTIES_DATA_MODAL: "customers/counterparties/dataModal",
		AGENTS_DATA_MODAL: "customers/agents/dataModal",
		CLIENTS_DATA_MODAL: "customers/clients/dataModal",
		//
		AUTODETECT_PHONE: "customers/autodetectPhone",
		AUTODETECT_PHONE_ERRORS: "customers/autodetectPhone/errors",
	};
	export type TypeOrderSlice = typeof ConstantCustomersSlice;
	export type ValueCustomersSlice =
		(typeof ConstantCustomersSlice)[keyof typeof ConstantCustomersSlice];
}
